<div class="wrapper">
    <div class="fadeMe" *ngIf="showOverlay" (click)="showOverlay = !showOverlay; datepicker.toggle()"></div>
    <div class="content-wrapper">
        <div class="br-section-wrapper" style="margin-top: 20px; padding: 8px;">
            <div class="row form-group" style="margin-top: 20px;">
                <div class="form-inline text-center" style="margin-left: 27px;">
                    <div class="form-group hidden">
                        <div class="input-group">
                            <input name="datepicker" class="form-control" style="display: none;" ngbDatepicker
                                #datepicker="ngbDatepicker" [autoClose]="false"
                                (dateSelect)="onDateSelection($event); closeDatePicker && datepicker.toggle()"
                                [displayMonths]="2" [dayTemplate]="t" outsideDays="hidden" [startDate]="fromDate">
                            <ng-template #t let-date let-focused="focused">
                                <span class="custom-day" [class.focused]="focused" [class.range]="isRange(date)"
                                    [class.faded]="isHovered(date) || isInside(date)" (mouseenter)="hoveredDate = date"
                                    (mouseleave)="hoveredDate = null">
                                    {{ date.day }}
                                </span>
                            </ng-template>
                        </div>
                    </div>
                    <div class="form-group">
                        <div>
                            <button class="btn height-27" style="background-color: #7cacd7;
                            color: #fff;
                            margin-right: 1rem;" (click)="resetFilter(true)">Today</button>
                        </div>
                        <div class="input-group pointer" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                            <label>From : &nbsp;</label>
                            <input disabled #dpFromDate class="form-control height-27" placeholder="dd-MM-yy"
                                style="width: 97px; color: black; cursor: pointer"
                                (click)="showOverlay = !showOverlay; datepicker.toggle()" name="dpFromDate"
                                [value]="formatDateForDisplay(fromDate)"
                                (input)="fromDate = validateInput(fromDate, dpFromDate.value);">

                            <div class="input-group-append">
                                <button class="btn btn-outline-secondary calendar height-27" type="button">
                                    <i class="fa fa-calendar" aria-hidden="true"></i>
                                </button>
                            </div>
                        </div>
                    </div>
                    <div class="form-group ml-2">
                        <div class="input-group pointer" (click)="showOverlay = !showOverlay; datepicker.toggle()">
                            <label>To : &nbsp;</label>
                            <input #dpToDate disabled class="form-control height-27 pointer" placeholder="yyyy-mm-dd"
                                style="width: 97px; color: black" name="dpToDate" [value]="formatDateForDisplay(toDate)"
                                (change)="datepicker.toggle()"
                                (input)="toDate = validateInput(toDate, dpToDate.value);">
                        </div>
                    </div>

                    <div class="form-group" style="margin-left: 10px;">
                        <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                            (click)="getBillOfLaddings(false)">Get Data</button>
                    </div>

                    <div class="form-group" style="margin-left: 10px;">
                        <button class="btn height-27" (click)="resetFilter()"
                            style="background-color: #67cd5b;color: #fff;">
                            <i class="fa fa-refresh"></i>
                        </button>
                    </div>

                    <div class="form-group" style="margin-left: 10px;">
                        <input type="text" class="form-control height-27" style="width: 97px" placeholder="Search.."
                            [(ngModel)]="filterQuery"
                            (keyup.enter)="page = 1; changeBackendPagination(page, size, false)" />
                        <span style="padding: 7px;
                margin-left: -3px;
                height: 28px !important;
                border-radius: 3px;
                cursor: pointer;
                color: #fff;
                background-color: #7cacd7;" (click)="page = 1; changeBackendPagination(page, size, false)"> <i
                                class="fa fa-search" aria-hidden="true"></i></span>
                    </div>

                    <div class="form-group" style="margin-left: 10px;">
                        <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                            (click)="hideOrShow = !hideOrShow">
                            <i class="fa fa-calculator" data-toggle="tooltip" title="Toggle totals"></i>
                            <!-- {{hideOrShow ? 'Hide':'Show'}} Total -->
                        </button>
                    </div>
                    <div class="form-group" style="margin-left: 10px;"> 
                        <button class="btn height-27" style="background-color: #7cacd7;color: #fff;"
                            (click)="clickToDownloadBolImagesList()">
                            <i class="fas fa-download" style="color: white !important"></i> Download
                            ({{selectedBolImagesList.length}}) BOL Images
                        </button>
                    </div>
                </div>
            </div>
            <div style="margin-top: 0px;">
                <div id="table-wrapper">
                    <div id="table-scroll" style="min-height: 300px;">
                        <table
                            *ngIf="billOfLaddingResponse?.billofladings && billOfLaddingResponse?.billofladings?.length > 0"
                            id=" " class="table table-insurance-inner " style="font-size: 11px !important;">
                            <thead>

                                <tr style="background-color: rgb(178, 173, 173);">
                                    <th class="wd-15p th-pd text-left" style="width: 6%;color: #007bff; padding-left: 20px !important">
                                        <input type="checkbox" (change)="selectAllBolImages()"
                            [checked]="selectedBolImagesList.length === bolImagesList.length"/>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" style="padding-left: 20px !important">
                                        <div class="plain-text-div">
                                            ID <i class="fa icon-for-plain-text"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.idStatus == 'norm' || sortingCurrentStatus.idStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.idStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.idStatus == 'desc'}"
                                                (click)="insertSortingObject('billofladingid')"></i>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd text-left" style="width: 6%;">
                                        <div class="plain-text-div">
                                            Order No.
                                            <i class="fa fa-sort"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.orderNoStatus == 'norm' || sortingCurrentStatus.orderNoStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.orderNoStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.orderNoStatus == 'desc'}"
                                                (click)="insertSortingObject('orderno')"></i>
                                        </div>
                                    </th>



                                    <th class="wd-15p th-pd" *ngIf="shouldShowCarrierSelection(user)" style="width: 8%">
                                        <i class="fa fa-sort icon"
                                            [ngClass]="{'fa-sort': sortingCurrentStatus.tenantStatus == 'norm' || sortingCurrentStatus.tenantStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.tenantStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.tenantStatus == 'desc'}"
                                            (click)="insertSortingObject('tenant')"></i>
                                        <select class="form-control input-sm custom-dropdowns selector"
                                            [(ngModel)]="carrierFilter"
                                            (change)="changeBackendPagination(0, noOfRecord);">
                                            <option [ngValue]="null">Carrier</option>
                                            <option [ngValue]="tenant.tenantId" *ngFor="let tenant of allowedTenants">
                                                {{tenant.tenantName}}
                                            </option>
                                        </select>
                                    </th>
                                    <th class="wd-15p th-pd" *ngIf="user.user.role.role == 'ROLE_TENANT_ADMIN'"
                                        style="width: 8%">
                                        <i class="fa fa-sort icon"
                                            [ngClass]="{'fa-sort': sortingCurrentStatus.billtypeStatus == 'norm' || sortingCurrentStatus.billtypeStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.billtypeStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.billtypeStatus == 'desc'}"
                                            (click)="insertSortingObject('billtype')"></i>
                                        <select class="form-control input-sm custom-dropdowns selector"
                                            [(ngModel)]="billtypeFilter"
                                            (change)="changeBackendPagination(0, noOfRecord);"
                                            (click)="checkBilltypeFiltersAvailability()">
                                            <option [ngValue]="null">Customer</option>
                                            <option [ngValue]="customer.displayName"
                                                *ngFor="let customer of allowedCustomers">
                                                {{customer.displayName}}
                                            </option>
                                        </select>
                                    </th>
                                    <th class="wd-5p th-pd line-height-27" style="width: 4%">
                                        <div class="plain-text-div">
                                            <i class="fa fa-sort icon"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.tacStatus == 'norm' || sortingCurrentStatus.tacStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.tacStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.tacStatus == 'desc'}"
                                                (click)="insertSortingObject('tac')"></i>
                                            <input type="text" placeholder="Site ID" class="site-entry-text"
                                                [(ngModel)]="tacFilter" (ngModelChange)="checkSiteIdFilter()"
                                                (keyup.enter)="changeBackendPagination(0, noOfRecord);">
                                        </div>
                                    </th>
                                    <th class="wd-30p th-pd" style="width: 17%;">
                                        <i class="fa fa-sort icon" style="z-index: 100; margin-left: 1px;"
                                            [ngClass]="{'fa-sort': sortingCurrentStatus.stationStatus == 'norm' || sortingCurrentStatus.stationStatus == 'NA', 
                    'fa-sort-asc': sortingCurrentStatus.stationStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.stationStatus == 'desc'}"
                                            (click)="insertSortingObject('station')"></i>
                                        <div class="input-container" style="padding-left: 15px">
                                            <ng-select [(ngModel)]="selectedDealer" [virtualScroll]="true"
                                                class="custom" (ngModelChange)="changeDealerFilter();displayCount();"
                                                placeholder="Site" (click)="checkDealerFiltersAvailability()">
                                                <ng-option *ngFor="let dealer of dealers; let dealerIndex = index"
                                                    [value]="dealer">
                                                    {{dealer.field1}}</ng-option>
                                            </ng-select>
                                            <!-- <ngx-select-dropdown [config]="dealerFilterConfig"
                          (change)="changeDealerFilter();" [options]="dealers"
                          (click)="checkDealerFiltersAvailability()"
                          [(ngModel)]="selectedDealer" [multiple]="false"></ngx-select-dropdown> -->
                                        </div>
                                    </th>
                                    <th class="wd-5p th-pd line-height-27">
                                        <div class="plain-text-div">
                                            CITY <i class="fa fa-sort icon-for-plain-text"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.cityStatus == 'norm' || sortingCurrentStatus.cityStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.cityStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.cityStatus == 'desc'}"
                                                (click)="insertSortingObject('city')"></i>
                                        </div>
                                    </th>

                                    <th class="wd-5p th-pd line-height-27" *ngIf="user?.user?.showProductInDashboard">
                                        <div class="plain-text-div">
                                            PRODUCT
                                            <!-- <i class="fa fa-sort icon-for-plain-text"
                          [ngClass]="{'fa-sort': sortingCurrentStatus.cityStatus == 'norm' || sortingCurrentStatus.cityStatus == 'NA', 
                        'fa-sort-asc': sortingCurrentStatus.cityStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.cityStatus == 'desc'}"
                          (click)="insertSortingObject('city')"></i> -->
                                        </div>
                                    </th>

                                    <th class="wd-15p th-pd" style="width: 13%;">
                                        <i class="fa fa-sort icon" style="margin-left: -3px;"
                                            [ngClass]="{'fa-sort': sortingCurrentStatus.terminalStatus == 'norm' || sortingCurrentStatus.terminalStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.terminalStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.terminalStatus == 'desc'}"
                                            (click)="insertSortingObject('terminal')"></i>
                                        <div class="input-container" style="padding-left: 15px">
                                            <ngx-select-dropdown [config]="terminalFilterConfig"
                                                (change)="changeTerminalFilter(selectedTerminal);changeBackendPagination(0, noOfRecord);"
                                                (click)="checkTerminalFiltersAvailability()" [options]="terminals"
                                                [(ngModel)]="selectedTerminal" [multiple]="false"></ngx-select-dropdown>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd" style="width: 15%;">
                                        <i class="fa fa-sort icon" style="margin-left: -3px;"
                                            [ngClass]="{'fa-sort': sortingCurrentStatus.supplierStatus == 'norm' || sortingCurrentStatus.supplierStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.supplierStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.supplierStatus == 'desc'}"
                                            (click)="insertSortingObject('supplier')"></i>

                                        <div class="input-container" style="padding-left: 15px">
                                            <ngx-select-dropdown [config]="supplierFilterConfig"
                                                (change)="changeSupplierFilter(selectedSupplier);changeBackendPagination(0, noOfRecord);"
                                                (click)="checkSupplierFiltersAvailability()" [options]="suppliers"
                                                [(ngModel)]="selectedSupplier" [multiple]="false"></ngx-select-dropdown>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd" style="width: 8%">
                                        <i class="fa fa-sort icon"
                                            [ngClass]="{'fa-sort': sortingCurrentStatus.statusStatus == 'norm' || sortingCurrentStatus.statusStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.statusStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.statusStatus == 'desc'}"
                                            (click)="insertSortingObject('status')"></i>
                                        <select class="form-control input-sm custom-dropdowns selector"
                                            [(ngModel)]="bolStatusFilter"
                                            (change)="changeBackendPagination(0, noOfRecord)">
                                            <option [ngValue]="null">Status</option>
                                            <option [ngValue]="1">Order Received</option>
                                            <option [ngValue]="10">Dispatched</option>
                                            <option [ngValue]="12">Enroute to Rack</option>
                                            <option [ngValue]="20">At Rack</option>
                                            <option [ngValue]="22">Left Rack</option>
                                            <option [ngValue]="24">At Location</option>
                                            <option [ngValue]="26">Finished</option>
                                            <option [ngValue]="40">Confirmed</option>
                                        </select>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27">
                                        <div class="plain-text-div">
                                            DATE
                                            <i class="fa fa-sort icon-for-plain-text"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.dateStatus == 'norm' || sortingCurrentStatus.dateStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.dateStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.dateStatus == 'desc'}"
                                                (click)="insertSortingObject('scheduleDate')"></i>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" style="width: 43px">
                                        <div class="plain-text-div">
                                            ETA
                                            <i class="fa fa-sort icon-for-plain-text"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.etaStatus == 'norm' || sortingCurrentStatus.etaStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.etaStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.etaStatus == 'desc'}"
                                                (click)="insertSortingObject('eta')"></i>
                                        </div>
                                        <!-- <div class="moveCalculatedTotalsUp"><b> Load Count: {{billOfLaddingResponse?.totalNoOfRecords}} </b></div> -->
                                    </th>
                                    <th class="wd-15p th-pd line-height-27"
                                        *ngIf="billOfLaddingResponse && billOfLaddingResponse.showLoads">
                                        <input type="text" [(ngModel)]="notesFilter" (blur)="getBillOfLaddings(false)"
                                            placeholder="Order No. &#xF002;" />
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" style="width: 59px;">
                                        <div class="plain-text-div">
                                            BOL#
                                            <i class="fa fa-sort icon-for-plain-text"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.bolStatus == 'norm' || sortingCurrentStatus.bolStatus == 'NA', 
                      'fa-sort-asc': sortingCurrentStatus.bolStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.bolStatus == 'desc'}"
                                                (click)="insertSortingObject('billoflading')"></i>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27 text-center">
                                        <div class="plain-text-div">
                                            BOL Sub
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27 text-center">
                                        <div class="plain-text-div">
                                            BOL
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27 text-center" *ngIf="showInvoices">
                                        <div class="plain-text-div">
                                            INVOICE
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow" style="width: 54px;">
                                        <div style="margin-top: -16px"><b>TOTAL </b>
                                            <i class="fa fa-sort icon-for-plain-text"
                                                [ngClass]="{'fa-sort': sortingCurrentStatus.totalStatus == 'norm' || sortingCurrentStatus.totalStatus == 'NA', 
                    'fa-sort-asc': sortingCurrentStatus.totalStatus == 'asc', 'fa-sort-desc': sortingCurrentStatus.totalStatus == 'desc'}"
                                                (click)="insertSortingObject('total')"></i>
                                        </div>
                                        <div class="moveCalculatedTotalsUp "><b> {{allPageTotals | number:'.'}} </b>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                                        <div style="margin-top: -16px"><b>REG </b></div>
                                        <div class="moveCalculatedTotalsUp "><b> {{totalRegQuantity | number:'.'}} </b>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                                        <div style="margin-top: -16px"><b>MID </b></div>
                                        <div class="moveCalculatedTotalsUp "><b> {{totalMidQuantity | number:'.'}} </b>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                                        <div style="margin-top: -16px"><b>SUP </b></div>
                                        <div class="moveCalculatedTotalsUp "><b> {{totalSupQuantity | number:'.'}} </b>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                                        <div style="margin-top: -16px"><b>ULSD </b></div>
                                        <div class="moveCalculatedTotalsUp "><b> {{totalUlsdQuantity | number:'.'}} </b>
                                        </div>
                                    </th>
                                    <th class="wd-15p th-pd line-height-27" *ngIf="hideOrShow">
                                        <div style="margin-top: -16px"><b>OTH </b></div>
                                        <div class="moveCalculatedTotalsUp "><b> {{totalOthQuantity | number:'.'}} </b>
                                        </div>
                                    </th>

                                </tr>
                            </thead>

                            <tbody>
                                <ng-container
                                    *ngFor="let item of billOfLaddingResponse && billOfLaddingResponse.billofladings; let parentIndex = index">

                                    <div
                                        *ngIf="(item.twoTerminalLoad || item.multipleSuppliers); then checkBolImageSentAvailability(item) && thenBlock else checkBolImageSentAvailability(item) && elseBlock">
                                    </div>
                                    <ng-template #thenBlock>
                                        <tr class=""
                                            [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers}"
                                            *ngFor="let billofladingdetail  of item && item.billofladingdetails">
                                            <td style="color: #007bff; padding-left: 20px !important">
                                                <input type="checkbox" [checked]="hasImage(item?.billOfLadingId)"
                                    (change)="onBolImageSelectFromGrid(item?.billOfLadingId, $event.target.checked)"/>
                                            </td>
                                            <td style="color: #007bff; padding-left: 20px !important">
                                                <a href="javascript:void(0)"
                                                    (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.billOfLadingId}}</a>
                                            </td>
                                            <td style="">
                                                <a href="javascript:void(0)"
                                                    (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.orderNo}}</a>
                                            </td>
                                            <td *ngIf="shouldShowCarrierSelection(user)">{{item?.tenantName}}</td>
                                            <td *ngIf="user.user.role.role == 'ROLE_TENANT_ADMIN'">
                                                {{item?.billofladingdetails[0]?.tblcard?.billtype?.displayName}}</td>
                                            <td>{{item?.tac}}</td>
                                            <td>{{item?.dealer ? item.dealer.dealer: ''}}</td>
                                            <td>{{item?.dealer ? item.dealer.city : ''}} {{item.dealer ?
                                                item.dealer.state : ''}}</td>
                                            <td *ngIf="user?.user?.showProductInDashboard"
                                                (click)="openModalForDetails(selectionModalForDetails, item)">
                                                <div class="row">
                                                    <div class="col-1 "> <i class="fa fa-plus product-expander"></i>
                                                    </div>
                                                    <div class="col-8 product-name">
                                                        {{billofladingdetail?.product?.productName}} </div>
                                                </div>
                                            </td>
                                            <td>{{billofladingdetail?.tblcard?.terminal?.terminalName}}</td>
                                            <td>
                                                {{billofladingdetail?.tblcard?
                                                billofladingdetail?.tblcard?.tblloadunder?
                                                billofladingdetail?.tblcard?.tblloadunder?.loadUnderName : '':''}}
                                            </td>
                                            <td>
                                                {{item?.bolstatus >= 40 ? 'Confirmed' : item?.bolstatus >= 26 ?
                                                'Finished' : item?.bolstatus == 1? 'Order Received':
                                                bolstatusMap.get(item.bolstatus+'')}}
                                            </td>
                                            <td>{{item?.scheduleDateFormatted}}</td>
                                            <td>{{item?.etaFormatted}}</td>
                                            <td *ngIf="item.showNotes">{{item.billofladingnotes?.loadingNotes}}</td>

                                            <td class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                                                [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                                                <div class="row">
                                                    <div style="margin-left: 16px;">
                                                        {{item.billOfLading?item.billOfLading:""}} </div>
                                                </div>
                                            </td>
                                            <td *ngIf="!item?.showDetails" class="bol-sub-unselected"><span
                                                    *ngFor="let detail of item?.billofladingdetails; let detailIndex = index"
                                                    (click)="item.showDetails = true">
                                                    {{detail.billofLadingSub}}<span *ngIf="detail.billofLadingSub"><i
                                                            class="fa fa-caret-down"></i></span>
                                                </span></td>
                                            <td *ngIf="item?.showDetails">
                                                <div class="bol-sub"
                                                    *ngFor="let detail of item?.billofladingdetails; let detailIndex = index"
                                                    (click)="item.showDetails = false">
                                                    {{detail?.product?.displayCode? detail?.product?.displayCode:
                                                    detail?.product?.productName}} - {{detail.billofLadingSub}}
                                                </div>
                                            </td>
                                            <td style="cursor: pointer; text-align: center;"
                                                class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                                                [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                                                <i *ngIf="checkBolImageSentAvailability(item)"
                                                    (click)="downloadFile(item.billOfLadingId, item.tenant, false)"
                                                    class="fa fa-download pointer"
                                                    style="cursor: pointer; margin-left: 40%;"></i>
                                            </td>
                                            <td *ngIf="showInvoices" style="text-align: center"
                                                class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                                                [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                                                <i *ngIf="checkBatchNumberAvailability(item)" style="margin-left: 40%;"
                                                    (click)="downloadFile(item.batchNumber, item.tenant, true)"
                                                    class="fa fa-download pointer"></i>
                                            </td>
                                            <td *ngIf="hideOrShow">{{item.loadTotal}}</td>
                                            <td *ngIf="hideOrShow">
                                                {{billofladingdetail?.product? billofladingdetail.product.productId == 1
                                                ?
                                                billofladingdetail.quantity: billofladingdetail.reg : ''}}
                                            </td>
                                            <td *ngIf="hideOrShow">
                                                {{billofladingdetail?.product? billofladingdetail.product.productId == 2
                                                ?
                                                billofladingdetail.quantity: billofladingdetail.mid : ''}}
                                            </td>
                                            <td *ngIf="hideOrShow">
                                                {{billofladingdetail?.product? billofladingdetail.product.productId == 3
                                                ?
                                                billofladingdetail.quantity: billofladingdetail.sup : ''}}
                                            </td>
                                            <td *ngIf="hideOrShow">
                                                {{billofladingdetail?.product? billofladingdetail.product.productId == 4
                                                ?
                                                billofladingdetail.quantity: billofladingdetail.ulsd : ''}}
                                            </td>
                                            <td *ngIf="hideOrShow">
                                                {{billofladingdetail?.product? billofladingdetail.product.productId > 4
                                                ?
                                                billofladingdetail.quantity: billofladingdetail.oth : ''}}
                                            </td>

                                        </tr>
                                    </ng-template>
                                    <ng-template #elseBlock>
                                        <tr class=""
                                            *ngFor="let billofladingdetail  of converToArray(item.billofladingdetails[0], parentIndex)">
                                             <td style="color: #007bff; padding-left: 20px !important">
                                                <input type="checkbox" [checked]="hasImage(item?.billOfLadingId)"
                                                (change)="onBolImageSelectFromGrid(item?.billOfLadingId, $event.target.checked)"/>
                                            </td>
                                            <td style="color: #007bff; padding-left: 20px !important">
                                                <a href="javascript:void(0)"
                                                    (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.billOfLadingId}}</a>
                                            </td>
                                            <td style="">
                                                <a href="javascript:void(0)"
                                                    (click)="openModalForDetails(selectionModalForDetails, item)">{{item?.orderNo}}</a>
                                            </td>
                                            <td *ngIf="shouldShowCarrierSelection(user)">{{item?.tenantName}}</td>
                                            <td *ngIf="user.user.role.role == 'ROLE_TENANT_ADMIN'">
                                                {{item?.billofladingdetails[0]?.tblcard?.billtype?.displayName}}</td>
                                            <td>{{item?.tac}}</td>
                                            <td>{{item?.dealer ? item.dealer.dealer: ''}}</td>
                                            <td>{{item?.dealer ? item.dealer.city : ''}} {{item.dealer ?
                                                item.dealer.state : ''}}</td>
                                            <td *ngIf="user?.user?.showProductInDashboard"
                                                (click)="openModalForDetails(selectionModalForDetails, item)">
                                                <div class="row">
                                                    <div class="col-1"> <i class="fa fa-plus product-expander"></i>
                                                    </div>
                                                    <div class="col-8 product-name">
                                                        {{billofladingdetail?.product?.productName}} </div>
                                                </div>
                                            </td>
                                            <td>{{billofladingdetail?.tblcard?.terminal?.terminalName}}</td>
                                            <td>
                                                {{billofladingdetail?.tblcard? billofladingdetail?.tblcard?.tblloadunder
                                                ?
                                                billofladingdetail?.tblcard?.tblloadunder?.loadUnderName : '':''}}
                                            </td>
                                            <td>
                                                {{item?.bolstatus >= 40 ? 'Confirmed' : item?.bolstatus >= 26 ?
                                                'Finished' : item?.bolstatus == 1? 'Order Received':
                                                bolstatusMap.get(item.bolstatus+'')}}
                                            </td>
                                            <td>{{item?.scheduleDateFormatted}}</td>
                                            <td>{{item?.etaFormatted}}</td>
                                            <td *ngIf="item.showNotes">{{item.billofladingnotes?.loadingNotes}}</td>

                                            <td class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                                                [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                                                <div class="row">
                                                    <div style="margin-left: 16px;">
                                                        {{item.billOfLading?item.billOfLading:""}} </div>
                                                </div>
                                            </td>
                                            <td *ngIf="!item?.showDetails" class="bol-sub-unselected"><span
                                                    *ngFor="let detail of item?.billofladingdetails; let detailIndex = index"
                                                    (click)="item.showDetails = true">
                                                    {{detail.billofLadingSub}}<span *ngIf="detail.billofLadingSub"><i
                                                            class="fa fa-caret-down"></i></span>
                                                </span></td>
                                            <td *ngIf="item?.showDetails">
                                                <div class="bol-sub"
                                                    *ngFor="let detail of item?.billofladingdetails; let detailIndex = index"
                                                    (click)="item.showDetails = false">
                                                    {{detail?.product?.displayCode? detail?.product?.displayCode:
                                                    detail?.product?.productName}} - {{detail.billofLadingSub}}
                                                </div>
                                            </td>
                                            <td style="cursor: pointer;"
                                                class="{{(item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1) ? 'styled-table-cell': 'same-load-cell'}}"
                                                [ngClass]="{'two-terminal':item.twoTerminalLoad || item.multipleSuppliers, 'styled-table-cell': item?.billofladingdetails?.length>1 && childIndex == item?.billofladingdetails?.length - 1}">
                                                <i *ngIf="checkBolImageSentAvailability(item)"
                                                    (click)="downloadFile(item.billOfLadingId, item.tenant, false)"
                                                    class="fa fa-download pointer"
                                                    style="cursor: pointer; margin-left: 40%"></i>
                                            </td>
                                            <td *ngIf="showInvoices" style="text-align: center">
                                                <!-- *ngIf="item.batchNumber && item.batchNumber != 0" -->
                                                <i class="fa fa-download pointer"
                                                    *ngIf="checkBatchNumberAvailability(item)"
                                                    style="cursor: pointer; margin-left: 40%; color: rgb(18, 92, 177)"
                                                    (click)="downloadFile(item.batchNumber, item.tenant, true)">
                                                </i>
                                            </td>

                                            <td *ngIf="hideOrShow">{{item.loadTotal}}</td>
                                            <td *ngIf="hideOrShow">{{billofladingdetail.reg}}</td>
                                            <td *ngIf="hideOrShow">{{billofladingdetail.mid}}</td>
                                            <td *ngIf="hideOrShow">{{billofladingdetail.sup}}</td>
                                            <td *ngIf="hideOrShow">{{billofladingdetail.ulsd}}</td>
                                            <td *ngIf="hideOrShow">{{billofladingdetail.oth}}</td>

                                        </tr>
                                    </ng-template>
                                </ng-container>
                            </tbody>
                        </table>

                        <div class="text-center bold" style="margin-top: 80px"
                            *ngIf="!billOfLaddingResponse?.billofladings || billOfLaddingResponse?.billofladings?.length <= 0">
                            ** No Records Found
                        </div>
                    </div>
                </div>
            </div>
        </div>


    </div>
</div>


<div class="fixed-bg" *ngIf="showProgressBar">
    <div class="progress">                      
        <div class="bar" style="width:0%" id="percentBar">        

        </div>                      
        <div class="percent-container">
            <p class="percent" id="percent">0%</p>
        </div>
    </div>
    <div id="download-text" class="download-text">Downloading...</div>
</div>
